"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Card_1 = __importDefault(require("../elements/Card"));
var Text_1 = __importDefault(require("../elements/Text"));
var Section_1 = __importDefault(require("../elements/Section"));
var ProcessCard_1 = require("../../defaults/ProcessCard");
var Icon_1 = __importDefault(require("../elements/Icon"));
var _helpers_1 = require("../../helpers");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Item = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  height: 100%;\n"], ["\n  text-align: center;\n  height: 100%;\n"])));
var ProcessCard = function (_a) {
    var items = _a.items, sectionConfig = _a.sectionConfig, cardConfig = _a.cardConfig;
    var mergedSectionConfig = _helpers_1.merge(ProcessCard_1.defaultSectionConfig, sectionConfig);
    var mergedCardConfig = _helpers_1.merge(ProcessCard_1.defaultCardConfig, cardConfig);
    return (react_1.default.createElement(Section_1.default, __assign({}, mergedSectionConfig),
        react_1.default.createElement(Card_1.default, __assign({}, mergedCardConfig),
            react_1.default.createElement("div", { className: "columns is-multiline" }, items.map(function (item, i) { return (react_1.default.createElement("div", { className: "column", key: i },
                react_1.default.createElement(Item, null,
                    item.iconConfig && (react_1.default.createElement(Icon_1.default, __assign({ dark: mergedSectionConfig.dark }, ProcessCard_1.defaultItemIconConfig, item.iconConfig))),
                    react_1.default.createElement(Text_1.default, __assign({ dark: mergedSectionConfig.dark }, ProcessCard_1.defaultItemTitleConfig, item.titleConfig)),
                    react_1.default.createElement(Text_1.default, __assign({ dark: mergedSectionConfig.dark }, ProcessCard_1.defaultItemDescriptionConfig, item.descriptionConfig))))); })))));
};
exports.default = ProcessCard;
var templateObject_1;
//# sourceMappingURL=ProcessCard.js.map